// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1-N1T","content":"styles_content__12Sv-"};